function FlickityAccessibility() {
    const carouselDots = document.querySelectorAll('.dot');

    carouselDots.forEach(dot => {
        dot.setAttribute('role', 'button');
        dot.setAttribute('tabindex', '0');
    });
}

export { FlickityAccessibility };
